import { Discipline } from '@chiroup/core';
import React from 'react';

export const ScheduleContext = React.createContext<{
  disciplines: Discipline[];
}>({
  disciplines: [],
});
